import type { NotificationSettingsUpdateRequestDeliverySettings } from './notificationSettingsUpdateRequestDeliverySettings';
import type { NotificationSettingsUpdateRequestTypeSettings } from './notificationSettingsUpdateRequestTypeSettings';

/**
 * 알림 설정 업데이트 요청
 */
export interface NotificationSettingsUpdateRequest {
  /** 알림 전달 설정 */
  deliverySettings?: NotificationSettingsUpdateRequestDeliverySettings;
  /** 알림 유형별 설정 */
  typeSettings?: NotificationSettingsUpdateRequestTypeSettings;
}
